import React, { useState, useEffect, useContext } from "react";
// import Barra from '../layout/Barra';
import { Link } from "react-router-dom";
import AlertaContext from "../../context/alertas/alertaContext";
import AuthContext from "../../context/autenticacion/authContext";
import ResultadoContext from "../../context/resultados/resultadoContext";
import Paginator from "react-hooks-paginator";
import TopBar from "../layout/TopBar";

const Resultados = (props) => {
  // extraer los valores del context
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;

  const authContext = useContext(AuthContext);
  const { usuarioAPIAutenticado } = authContext;

  const resultadoContext = useContext(ResultadoContext);
  const {
    resultados,
    paginaActual,
    obtenerResultados,
    establecerPaginaActual,
    seleccionarResultado,
  } = resultadoContext;

  const user = JSON.parse(localStorage.getItem("usuario"));

  useEffect(() => {
    usuarioAPIAutenticado(1);
    consultarResultados();
    /*if(idSeleccionado !== 0) {
            props.history.push.target('/resultadosDetalle');
        }*/
    //eslint-disable-next-line
  }, [paginaActual]);

  // State para la consulta de información
  const [filtros, guardarFiltros] = useState({
    entidadId: user.entidadId,
    fechaInicial: "",
    fechaFin: "",
    folio: "",
    paciente: "",
    page: 1,
    pagesize: 10,
    sort: "fecha DESC",
    pacienteId: props.location.state ? props.location.state.pacienteId : null,
  });

  const [offset, guardarOffset] = useState(0);
  const [filtroQuery, guardarFiltroQuery] = useState({
    filter: "",
  });

  // Extraemos los datos de los filtros
  const {
    entidadId,
    fechaInicial,
    fechaFin,
    folio,
    paciente,
    page,
    pagesize,
    sort,
    pacienteId,
  } = filtros;

  const { filter } = filtroQuery;

  const onChange = (e) => {
    guardarFiltros({
      ...filtros,
      [e.target.name]: e.target.value,
    });
  };

  const onSelectPagination = (e) => {
    guardarFiltros({
      ...filtros,
      page: e,
    });
    establecerPaginaActual(e);
  };

  const consultarResultados = () => {
    let id = pacienteId ? pacienteId : entidadId;
    obtenerResultados({
      entidadId: id,
      sort,
      page,
      pagesize,
      filter,
    });
  };

  const seleccionarIdResultado = (id) => {
    seleccionarResultado(id);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (
      fechaInicial === "" &&
      fechaFin === "" &&
      folio.trim() === "" &&
      paciente.trim() === ""
    ) {
      mostrarAlerta(
        "Es necesario indicar al menos un valor de búsqueda",
        "alert-danger"
      );
      return;
    }

    if (
      (fechaInicial !== "" && fechaFin === "") ||
      (fechaInicial === "" && fechaFin !== "")
    ) {
      mostrarAlerta(
        "Es necesario indicar el rango de fechas a buscar",
        "alert-danger"
      );
      return;
    }

    let filter = "";
    let fs1 = fechaInicial.split("-");
    let fs2 = fechaFin.split("-");

    let f1 = fs1[2] + "/" + fs1[1] + "/" + fs1[0];
    let f2 = fs2[2] + "/" + fs2[1] + "/" + fs2[0];

    if (fechaInicial !== "" && fechaFin !== "") {
      filter += `AND fecha >= ''${f1}'' AND fecha <= ''${f2}'' `;
    }
    filter += folio.trim() !== "" ? `AND folio LIKE ''%${folio}%'' ` : "";
    filter +=
      paciente.trim() !== "" ? `AND paciente LIKE ''%${paciente}%'' ` : "";

    filter = filter.substring(4, filter.length);

    guardarFiltroQuery({
      ...filtroQuery,
      filter: filter,
    });

    establecerPaginaActual(1);

    let id = pacienteId ? pacienteId : entidadId;
    obtenerResultados({
      entidadId: id,
      sort,
      page,
      pagesize,
      filter,
    });
  };

  return (
    <div>
      <TopBar />
      <div className="container">
        {/* <Barra /> */}
        <section>
          <div className="my30 card p10">
            {/*<div className="row">
                            <div className="col-md-6 text-left">
                                <h3 className="my0">Paciente: { usuario ? <span className="bold"> {usuario.nombre} </span> : null } </h3>
                                <p className="text-muted">Mostrando del <span className="bold"> 1 </span> al <span className="bold"> 15 </span> de <span className="bold"> 37 </span> registros encontrados</p>
                            </div>
                            <div className="col-md-6 text-right">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => cerrarSesion()}>Cerrar Sesión</button>
                            </div>
                        </div>*/}
            {alerta ? (
              <div
                className={`alert ${alerta.categoria} alert-dismissible fade in`}
              >
                {" "}
                {alerta.msg}{" "}
              </div>
            ) : null}
            <form onSubmit={onSubmit}>
              <div className="row p10">
                <div className="col-md-2 px5">
                  <label htmlFor="">Fecha inicial</label>
                  <div className="inupt-group">
                    <input
                      type="date"
                      id="fechaInicial"
                      name="fechaInicial"
                      value={fechaInicial}
                      onChange={onChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-2 px5">
                  <label htmlFor="">Fecha final</label>
                  <div className="inupt-group">
                    <input
                      type="date"
                      id="fechaFin"
                      name="fechaFin"
                      value={fechaFin}
                      onChange={onChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-2 px5">
                  <label htmlFor="">Folio</label>
                  <div className="inupt-group">
                    <input
                      type="text"
                      id="folio"
                      name="folio"
                      value={folio}
                      onChange={onChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-5 px5">
                  <label htmlFor="">Nombre</label>
                  <div className="inupt-group">
                    <input
                      type="text"
                      id="paciente"
                      name="paciente"
                      value={paciente}
                      onChange={onChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-1 px5">
                  <button type="submit" className="btn btn-primary mt33">
                    Buscar
                  </button>
                </div>
              </div>
            </form>
            <div className="row p15">
              <div className="table">
                {resultados.length === 0 ? (
                  <p className="text-center">No existen resultados</p>
                ) : (
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Folio</th>
                        <th>Fecha</th>
                        <th>Paciente</th>
                      </tr>
                    </thead>

                    <tbody>
                      {resultados.map((resultado) => (
                        <tr
                          key={resultado.transaccionId}
                          className={
                            resultado.ROW_NUMBER % 2 === 0 ? "active" : ""
                          }
                        >
                          <th className="width15" scope="row">
                            <Link
                              to={{
                                pathname: "/resultadosDetalle",
                                state: { pacienteId: pacienteId },
                              }}
                              onClick={() => {
                                seleccionarIdResultado(resultado.transaccionId);
                              }}
                            >
                              <i className="bi bi-file-earmark"></i>
                            </Link>
                          </th>
                          <td>{resultado.folio}</td>
                          <td>{resultado.fecha}</td>
                          <td>{resultado.paciente}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                <Paginator
                  totalRecords={
                    resultados.length > 0 ? resultados[0].Total_Rows : 0
                  }
                  pageLimit={pagesize}
                  pageNeighbours={3}
                  setOffset={guardarOffset}
                  currentPage={paginaActual}
                  setCurrentPage={onSelectPagination}
                  pageNextText="Siguiente >"
                  pagePrevText="Anterior <"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Resultados;
